__turbopack_context__.v({
  "article": "EJpD_G_article",
  "description": "EJpD_G_description",
  "image": "EJpD_G_image",
  "item": "EJpD_G_item",
  "itemAnimation": "EJpD_G_itemAnimation",
  "list": "EJpD_G_list",
  "moreButton": "EJpD_G_moreButton",
  "swiperWrapper": "EJpD_G_swiperWrapper",
  "title": "EJpD_G_title",
});
